import { createContext } from 'react';
import { FeatureFlagModel, defaultFeatureFlagModel } from "../types/featureFlagModel"

export const FeatureFlagContext = createContext<FeatureFlagModel>(defaultFeatureFlagModel);